import { isAndroid,isiOS } from "@/utils/index.js";

const _iosCallbackQueue = []
window.CallBack = (res) => {
    console.log('%c[IOS-BRIDGE] window.CallBack 被原生调用!', 'color:#409eff;font-weight:bold')
    console.log('[IOS-BRIDGE] CallBack res:', res, '| 队列剩余长度:', _iosCallbackQueue.length)
    const cb = _iosCallbackQueue.shift()
    if (cb) {
        let params = res && typeof res.data !== 'string' ? JSON.stringify(res.data) : (res ? res.data : res)
        console.log('[IOS-BRIDGE] 取出 callback 执行, params:', params)
        cb(params)
        console.log('[IOS-BRIDGE] callback 执行完毕 ✅')
    } else {
        console.warn('[IOS-BRIDGE] ⚠️ CallBack 被调用但队列为空！多余的回调或 push 失败')
    }
}

function iosBridge(name, data, callback) {
    let params = {
        actionName: name,
        callbackName : callback.name || 'CallBack',
        parameters: data
    }
    _iosCallbackQueue.push(callback)
    console.log('[IOS-BRIDGE] iosBridge name:', name, '| callback 入队, 队列长度:', _iosCallbackQueue.length)
    try {
        window.webkit.messageHandlers.nativeHandler.postMessage(JSON.stringify(params))
        console.log('[IOS-BRIDGE] postMessage 成功, name:', name, '| 等待原生 CallBack 回调...')
    } catch (e) {
        console.error('[IOS-BRIDGE] ❌ postMessage 失败!', e.message)
        _iosCallbackQueue.pop()
        console.warn('[IOS-BRIDGE] callback 已出队(未执行), name:', name, '| 队列剩余:', _iosCallbackQueue.length)
    }
}

const CallbackManager = (() => {
    let _seq = 0
    const _callbacks = {}

    const register = (callback) => {
        const id = `cb_${++_seq}`
        _callbacks[id] = callback
        return id
    }

    const dispatch = (payload) => {
        let parsed
        try {
            parsed = typeof payload === 'string' ? JSON.parse(payload) : payload
        } catch (e) {
            console.error('[CallbackManager] 解析回调参数失败:', payload)
            return
        }
        const { callbackId, result } = parsed
        if (!callbackId || !_callbacks[callbackId]) {
            console.warn('[CallbackManager] 无效的 callbackId:', callbackId)
            return
        }
        _callbacks[callbackId](result)
        delete _callbacks[callbackId]
    }

    window.freshApp_callback = dispatch

    return { register }
})()

const METHOD_DESCRIPTORS = {
    takePhoto:       { async: true },
    pickPhoto:       { async: true },
    goHome:          {},
    takePhotoForOCR:             {},
    faceIdentify:                {},
    getTokenInfo:                {},
    getHeaderInfo:               {},
    closeWebview:                {},
    login:                       {},
    loginAndCloseCurrentActivity: {},
    getTaskbarHeight:            {},

    copy:            { payload: 'raw' },
    pointPageView:   { payload: 'json' },
    pointPageLeave:  { payload: 'json' },
}

export default function bridge(name, data, callback = () => {}) {
    try {
        var _origCb = callback
        callback = function () {
            console.log('%c[BRIDGE-DIAG] ✅ callback 被触发!', 'color:#67c23a;font-weight:bold', '| name:', name, '| arguments:', arguments)
            return _origCb.apply(null, arguments)
        }
        console.log('[BRIDGE-DIAG] ===== bridge 调用 =====')
        console.log('[BRIDGE-DIAG] actionName:', name)
        console.log('[BRIDGE-DIAG] isiOS():', isiOS())
        console.log('[BRIDGE-DIAG] isAndroid():', isAndroid())
        console.log('[BRIDGE-DIAG] window.WebViewJavascriptBridge:', !!window.WebViewJavascriptBridge)
        console.log('[BRIDGE-DIAG] webkit.messageHandlers:', !!(window.webkit && window.webkit.messageHandlers))
        console.log('[BRIDGE-DIAG] webkit.messageHandlers.nativeHandler:', !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeHandler))
        console.log('[BRIDGE-DIAG] UA:', navigator.userAgent)
        console.log('[BRIDGE-DIAG] callback.name:', callback.name || '(匿名函数)')

        if (isiOS()) {
            console.log('[BRIDGE-DIAG] ✅ 进入 iOS 分支 → 调用 iosBridge')
            iosBridge(name, data, callback)
        } else if (isAndroid() && window.WebViewJavascriptBridge) {
            console.log('[BRIDGE-DIAG] ✅ 进入 Android 分支')
            let params = ''
            if (data) {
                params = JSON.stringify(data)
            }

            const descriptor = METHOD_DESCRIPTORS[name]
            if (!descriptor) {
                callback()
                return
            }

            const resolveArg = () => {
                if (descriptor.payload === 'raw') return data
                if (descriptor.payload === 'json') return params
                return undefined
            }

            if (descriptor.async) {
                const callbackId = CallbackManager.register(callback)
                console.log('[BRIDGE-DIAG] Android async, callbackId:', callbackId, '| name:', name)
                const arg = resolveArg()
                arg !== undefined
                    ? window.WebViewJavascriptBridge[name](arg, callbackId)
                    : window.WebViewJavascriptBridge[name](callbackId)
                console.log('[BRIDGE-DIAG] Android async 已发起, 等待 freshApp_callback 回调...')
                return
            }

            const arg = resolveArg()
            console.log('[BRIDGE-DIAG] Android 同步调用 WebViewJavascriptBridge.' + name + '(), arg:', arg)
            const result = arg !== undefined
                ? window.WebViewJavascriptBridge[name](arg)
                : window.WebViewJavascriptBridge[name]()
            console.log('[BRIDGE-DIAG] Android 同步返回 result:', result, '| 类型:', typeof result)
            callback(result)
        } else {
            console.warn('[BRIDGE-DIAG] ❌ 进入 ELSE 分支（非iOS/非Android或Bridge未就绪）')
            console.warn('[BRIDGE-DIAG]    isiOS()=', isiOS(), 'isAndroid()=', isAndroid(), 'WebViewJavascriptBridge=', !!window.WebViewJavascriptBridge)
            console.warn('[BRIDGE-DIAG]    将以无参数调用 callback() → 返回 undefined!')
            callback()
        }
    } catch (error) {
        console.error('[BRIDGE-DIAG] ❌ Bridge 调用异常:', error)
        callback()
    }
}



// WEBPACK FOOTER //
// ./src/utils/bridge.js